// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ChartController from "./chart_controller"
application.register("chart", ChartController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import CollapsibleController from "./collapsible_controller"
application.register("collapsible", CollapsibleController)

import DestinationTypeController from "./destination_type_controller"
application.register("destination-type", DestinationTypeController)

import DrawerController from "./drawer_controller"
application.register("drawer", DrawerController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import PostalCodeLookupController from "./postal_code_lookup_controller"
application.register("postal-code-lookup", PostalCodeLookupController)

import ReimbursementController from "./reimbursement_controller"
application.register("reimbursement", ReimbursementController)

import SubmitController from "./submit_controller"
application.register("submit", SubmitController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)

import ReminderScheduleController from "./reminder_schedule_controller"
application.register("reminder-schedule", ReminderScheduleController)

import ScheduleTypeController from "./schedule_type_controller"
application.register("schedule-type", ScheduleTypeController)

import ToggleSectionsController from "./toggle_sections_controller"
application.register("toggle-sections", ToggleSectionsController)
